import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=792e19c6&scoped=true"
import script from "./foot.vue?vue&type=script&lang=ts"
export * from "./foot.vue?vue&type=script&lang=ts"
import style0 from "./foot.vue?vue&type=style&index=0&id=792e19c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792e19c6",
  null
  
)

export default component.exports